var isArray = function isArray(value) {
  return value instanceof Array;
};

export default isArray;